import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Forms from './components/Forms';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { useParams } from 'react-router-dom';

const BeneficiosCadastro = ({
  isReadOnly = false,
  id: propId,
  hideHeader = false
}) => {
  const { id: paramId } = useParams();
  const id = propId || paramId;
  const isEditing = !!id && !isReadOnly;
  const isViewing = isReadOnly;
  return <Container fluid>
      {!hideHeader && <Row>
          <Col md={12}>
            <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Beneficios',
          path: '/pages/pedidos'
        }, {
          name: isViewing ? 'Detalhes do Beneficios' : isEditing ? 'Editar Beneficios' : 'Novo Beneficios'
        }]} />
          </Col>
        </Row>}
      
      <Row>
        <Col md={12}>
          <Forms isReadOnly={isReadOnly} />
        </Col>
      </Row>
    </Container>;
};

export default BeneficiosCadastro;
